<script setup lang="ts">
  import { computed } from 'vue';
  import PosUiIcon from '@/components/pos-v2/ui/PosUiIcon.vue';
  import { useConnectivity } from '@/composition/use-connectivity';

  const { status } = useConnectivity();

  // No auth gate needed: the controller idles at 'online' while logged out.
  const visible = computed(
    () => status.value === 'offline' || status.value === 'restored'
  );
</script>

<template>
  <div
    v-if="visible"
    class="connectivity-banner hidden-print-only"
    :class="status === 'offline' ? 'is-offline' : 'is-restored'"
  >
    <template v-if="status === 'offline'">
      <PosUiIcon name="wifi-off" class="banner-icon" />
      <span class="banner-title">{{ $t('connectivity.offlineTitle') }}</span>
      <span class="banner-hint">{{ $t('connectivity.offlineHint') }}</span>
    </template>
    <template v-else>
      <PosUiIcon name="check-circle-outline" class="banner-icon" />
      <span class="banner-title">{{ $t('connectivity.restoredTitle') }}</span>
    </template>
  </div>
</template>

<style scoped lang="scss">
  .connectivity-banner {
    @apply tw-flex tw-items-center tw-border-0 tw-border-b tw-border-solid tw-px-4 tw-py-2;
    // .pos-shell flex rules in App.vue only target `> .v-toolbar, > header`,
    // so the banner declares its own no-shrink sizing.
    flex: 0 0 auto;

    &.is-offline {
      @apply tw-border-red-200 tw-bg-red-50;

      .banner-icon {
        @apply tw-text-red-700;
      }
    }

    &.is-restored {
      @apply tw-border-emerald-200 tw-bg-emerald-50;

      .banner-icon {
        @apply tw-text-emerald-700;
      }
    }

    .banner-icon {
      @apply tw-mr-2 tw-shrink-0 tw-text-lg;
    }

    .banner-title {
      @apply tw-mr-2 tw-text-sm tw-font-semibold tw-text-neutral-900;
    }

    .banner-hint {
      @apply tw-text-sm tw-text-neutral-600;

      @media (max-width: 599px) {
        display: none;
      }
    }
  }
</style>
